
import { Vue, Component } from "vue-property-decorator";

@Component({ name: "icon-user" })
export default class IconUser extends Vue {
  sData: string = require("@icon/feather/user.svg");
}
